import { render } from "./YesNoNotification.vue?vue&type=template&id=48e2b710"
import script from "./YesNoNotification.vue?vue&type=script&lang=js"
export * from "./YesNoNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__